import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
import { IBandhaiDetails } from "../bandhaiModel";

export const findAllBandhai = createAsyncThunk(
  "Bandhai/FindAllBandhai",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/FindAllBandhai`,
        formData,
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Bandhai", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createBandhai = createAsyncThunk(
  "Bandhai/InsertBandhai",
  async (ghat: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/InsertBandhai`,
        ghat,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bandhai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateBandhai = createAsyncThunk(
  "Bandhai/UpdateBandhai",
  async (ghat: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/UpdateBandhai`,
        ghat,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Bandhai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhai = createAsyncThunk(
  "Bandhai/DeleteBandhai",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/DeleteBandhai`,
        { bandhai_issue_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Bandhai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBandhaiById = createAsyncThunk(
  "Bandhai/FindByIDBandhai",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/FindByIDBandhai`,
        { bandhai_issue_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        bandhai_issue_guid: result.bandhai_issue_guid,
        issue_no: result.issue_no,
        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        address: result.address,
        issue_date: result.issue_date ? moment(result.issue_date).toDate() : "",
        approx_delivery_date: result.approx_delivery_date
          ? moment(result.approx_delivery_date).toDate()
          : "",
        given_amount: result.given_amount,
        remarks: result.remarks,
        karigarIdWiseOutStandingAmount: result.karigarIdWiseOutStandingAmount,
        SizeDetails: result.SizeDetails,
        bandhai_order: result.bandhai_order
          ? result.bandhai_order.map((gitem: any) => {
              return {
                id: gitem.id,
                bandhai_issue_id: gitem.bandhai_issue_id,
                priority: gitem.priority,
                approx_delivery_date: gitem.delivery_date
                  ? moment(gitem.delivery_date).toDate()
                  : "",
                process_id: gitem.process_id,
                order_no: gitem.order_no,
                order_id: gitem.order_id,
                item_id: gitem.item_id,
                item_name: gitem.item_name,
                item_category_id: gitem.item_category_id,
                item_subcategory_id: gitem.item_subcategory_id,
                category_name: gitem.category_name,
                item_subcategory_name: gitem.item_subcategory_name,
                purity_id: gitem.purity_id,
                purity: gitem.purity,
                Carat: gitem.Carat,
                PurityValue: gitem.PurityValue,
                color: gitem.color,
                size: gitem.size,
                weight: gitem.weight,
                remarks: gitem.remarks,
                ProcessImage: gitem.ProcessImage,
                bandhaiprocessimage: gitem.bandhaiprocessimage,
                image: gitem.image,
                approval_items: gitem.approval_items?.length
                  ? gitem.approval_items?.map((approvalItem: any) => {
                      return {
                        ...approvalItem,
                        IssueDate: approvalItem.IssueDate
                          ? moment(
                              approvalItem.IssueDate,
                              "YYYY-MM-DD",
                            ).toDate()
                          : null,
                      };
                    })
                  : [],
              };
            })
          : [],
        bandhai_Entry_item: result.bandhai_Entry_item
          ? result.bandhai_Entry_item.map((results: any) => {
              return {
                id: results.id,
                bandhai_issue_id: results.bandhai_issue_id,
                IssueDate: results?.IssueDate
                  ? moment(results.IssueDate, "YYYY-MM-DD").toDate()
                  : null,
                Purity: results.Purity,
                Carat: results.Carat,
                item_id: results.item_id,
                item_name: results.item_name,
                given_weight: results.given_weight,
                given_purity: results.given_purity,
                PurityID: results.PurityID,
                given_wastage: results.given_wastage,
                phine: results.phine,
                pcs: results.pcs,
              };
            })
          : [],
      } as IBandhaiDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bandhai:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhaiOrderItems = createAsyncThunk(
  "Bandhai/DeleteBandhaiOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/DeleteBandhaiOrder`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Order ITem:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteBandhaiEntryItems = createAsyncThunk(
  "Bandhai/DeleteBandhaiEntryItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/DeleteBandhaiEntryItem`,
        { id: ID },
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Entry Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhaiApprovalItem = createAsyncThunk(
  "Bandhai/DeleteBandhaiApprovalItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/DeleteBandhaiApprovalItem`,
        { id: ID },
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Approval Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
